import styled from "styled-components";

export const CheckoutSuccessContainer = styled.div`
  height: 100vh;
  background-color: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  a {
    text-decoration: none;
  }
`;
